import axios from 'axios';
import route from 'ziggyRoute';

export default {
    async get(params = {}) {
        let url = route('scopes.dropdowns');
        return await axios.get(url, { params });
    },
};
